import React from 'react';
import Button, { buttonColor, buttonType } from 'Components/Button';
import NotificationManager from 'dom-managers/notification';
import { BOAT_TYPE_LIST } from 'constants/boatApplication';

export default ({ boat, handleSaveStep, handleDeleteDraft, markCurrentStepAsSaved, stepIsChanged, user, text }) => {
  const getBoatTypeKey = () => {
    const boatType = BOAT_TYPE_LIST.find(type => type.value === boat.boatType);

    return boatType.name;
  };

  const Buttons = handleSaveStep ? (
    <React.Fragment>
      {stepIsChanged && (
        <Button
          label='Save'
          type={buttonType.primary}
          color={buttonColor.blue}
          buttonClassName='_height_30 _width_90'
          onClick={() => {
            handleSaveStep().then(() => {
              markCurrentStepAsSaved();
              NotificationManager.success('note', 'Your changes were saved successfully.');
            });
          }}
        />
      )}
      {boat.status === 'DRAFT' && (
        <Button
          label='Delete'
          type={buttonType.primary}
          color={buttonColor.planeRed}
          buttonClassName='_height_30 _width_90'
          onClick={handleDeleteDraft}
        />
      )}
    </React.Fragment>
  ) : null;

  const headerText = text ? text : `${isFinite(boat.id) ? '' : 'New '}${getBoatTypeKey()} Application`;

  //TODO header wrapped in div instead section to avoid conflict with old pre-bem styles change it if they will be removed
  return (
    <section className='application-header'>
      <div className='header-text-wrapper'>
        <div
          className='go-back-to-list-header-button'
          onClick={() => {
            user.goToList();
          }}
        >
          Back
        </div>
        <header>{headerText}</header>
      </div>
      <div className='header-buttons-wrapper'>{Buttons}</div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/Header.jsx